// theme.service.ts
import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { AppTheme, ThemeMode } from '@core/enums/theme.enum';
import { HMS_THEME } from '@core/constants/session.const';

interface IHMSThemeModel {
  theme: string;
  mode: string;
}

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public hmsTheme: IHMSThemeModel = {
    theme: '',
    mode: '',
  };

  constructor(public storageService: StorageService) {
    this.loadInitialTheme();
  }

  private async loadInitialTheme() {
    try {
      const appTheme = await this.storageService.get(HMS_THEME);
      this.hmsTheme = appTheme
        ? (JSON.parse(appTheme) as IHMSThemeModel)
        : {
            theme: AppTheme.Theme1,
            mode: ThemeMode.Light,
          };
    } catch {
      this.hmsTheme = {
        theme: AppTheme.Theme1,
        mode: ThemeMode.Light,
      };
    }
    this.setTheme(this.hmsTheme.theme);
    this.setMode(this.hmsTheme.mode);
  }

  async setTheme(theme: string) {
    document.documentElement.setAttribute('class', 'theme-' + theme);
    this.hmsTheme.theme = theme;
    await this.storageService.set(HMS_THEME, JSON.stringify(this.hmsTheme));
  }

  async setMode(mode: string) {
    document.documentElement.setAttribute('theme-mode', mode);
    this.hmsTheme.mode = mode;
    await this.storageService.set(HMS_THEME, JSON.stringify(this.hmsTheme));
  }

  toggleMode() {
    this.setMode(
      this.hmsTheme.mode === ThemeMode.Dark ? ThemeMode.Light : ThemeMode.Dark
    );
  }

  getActiveTheme() {
    return this.hmsTheme.theme;
  }

  getThemeMode() {
    return this.hmsTheme.mode;
  }

  // New method to set theme based on checkbox value
  setDynamicTheme(themeValue: string) {
    const theme = `${themeValue}`;
    this.setTheme(theme);
  }
}
